import { trim } from 'lodash';
export function validateDraftFieldNotEmpty(field, fallback) {
    return trim(String(field)).length ? field : fallback;
}
//# sourceMappingURL=draft-validation.js.map